<template>
  <div class="commonHeader">
    <mt-header fixed :title=title>
      <mt-button icon="back" @click="back" slot="left" v-if="showBack"></mt-button>
    </mt-header>
  </div>
</template>

<script>
export default {
  name: "commonHeader",
  props:{
    title:String,
    showBack:{
      default:true
    }
  },
  methods:{
    back(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>

</style>
<style lang="less">
  .commonHeader{
    .mint-header-title{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 500;
    }
  }
  
</style>




// WEBPACK FOOTER //
// src/components/mtHeader.vue